<template>
    <v-card class="elevation-12 px-0">
        <v-card-text class="px-6" id="scroller" v-if="items.length">
            <v-sheet
                tile
                color="#f9f9f9"
                class="pa-4 rounded-lg"
            >
                <div class="d-flex justify-space-between">
                    <p class="primary--text subtitle-1 font-weight-bold">
                        ITEMS
                    </p>
                    <p class="primary--text subtitle-1 font-weight-bold">
                        PRICE
                    </p>
                </div>

                <template v-for="(item, n) in items">
                    <invoice-item
                        :key="n"
                        :item="{ ...item, index: n+1 }"
                        :show="false"
                    />
                    <hr
                        class="line my-3"
                        :key="n+'line'"
                        v-if="n+1 !== items.length"
                    />
                </template>
            </v-sheet>

            <hr class="line mt-5 mb-3" />
            <div class="d-flex justify-space-between px-4 mb-5">
                <p class="primary--text text-h5">
                    Total
                </p>
                <div class="text-right">
                    <p class="primary--text title font-weight-bold my-0">
                        ${{ formatAmount(totalAmount) }}
                    </p>
                    <p class="my-0 grey--text subtitle-2">
                        (229,494 - 235,000 KES)
                    </p>
                </div>
            </div>

            <v-textarea
                outlined
                class="rounded-lg"
                name="input-7-4"
                label="Write comment"
                style="height: 135px"
            ></v-textarea>
        </v-card-text>
        <v-card-actions class="footer px-6">
            <div>
                <p class="my-0 black--text subtitle-1 font-weight-bold">
                    INV-KA-17689
                </p>
                <p class="my-0 grey--text subtitle-2">
                    Due in {{ invoice.dueDays }} Days
                    <v-icon
                        small
                        class="pa-0 ml-n2"
                    >
                        mdi-chevron-right
                    </v-icon>
                </p>
            </div>
            <v-spacer />
            <v-btn
                class="rounded-xl white--text px-6 text-none"
                color="primary"
                @click="$emit('send')"
            >
                Send Invoice
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import InvoiceItem from '../components/invoice-item.vue';

export default {
    components: {
        InvoiceItem,
    },
    props: {
        invoice: Object,
    },
    computed: {
        items() {
            return this.invoice.items;
        },
        totalAmount() {
            return this.items.map(key => key.price).reduce((b, a) => Number(b) + Number(a), 0)
        },
    }
}
</script>

<style scoped>
#scroller {
    max-height: 70vh;
    overflow-y: auto;
}
</style>